import BookPage from 'components/finance/BookPage';

/** Admin › Finanzas › Bancos: cuentas bancarias y tarjetas, una cuenta y un mes a la vez. */
export default function FinanzasBancos() {
  return <BookPage book="bancos" />;
}
